/* Bezorgklok: "Besteld binnen 13:18:42 en het wordt morgen bezorgd."
   Gebouwd 2026-09-03 op verzoek van Stijn.

   Staat op de productpagina in het icoonrijtje op de regel over de besteltijd, en in
   de winkelwagenlade en op de winkelwagenpagina boven het totaal.

   DE BELOFTE
   Bestellen kan tot middernacht, alle dagen van de week. Dat is wat de
   productpagina, de homepage en de aankondigingsbalk al beloven. Op de
   winkelwagenpagina staat voor vrijdag 22:00; Stijn heeft op 2026-09-03 besloten
   overal 23:59 aan te houden omdat er 's avonds laat op vrijdag nauwelijks besteld
   wordt. Dat is een bewuste afweging, geen vergissing.

   De bezorgdag is de eerstvolgende dag die geen zondag en geen feestdag is. Dat komt
   uit op precies wat de winkelwagenpagina belooft: ma t/m do de volgende dag,
   vrijdag zaterdag, zaterdag en zondag maandag.

   NEDERLANDSE TIJD
   De klok rekent met Europe/Amsterdam en niet met de klok van de bezoeker. Anders
   ziet iemand in Spanje een uur verschil en klopt de belofte niet.

   FEESTDAGEN
   De lijst hieronder moet één keer per jaar bij. Loopt hij af, dan blijft de klok
   gewoon werken; hij slaat dan alleen geen feestdagen meer over. */

(function () {
  /* Middernacht, niet 23:59. Je kunt tot 23:59:59 bestellen en dat telt nog mee, dus
     het einde van de dag is 24:00:00. Date.UTC rekent uur 24 vanzelf door naar
     00:00 van de volgende dag.

     Dit was eerst 23:59:00 en dat scheelde een minuut: om 23:59:30 was de klok al
     afgelopen terwijl je dan nog gewoon kon bestellen. Stijn merkte het op 2026-09-03
     op. Bijkomend voordeel: de minuten van de aftelling lopen nu gelijk met het hele
     uur, wat een stuk logischer leest. */
  var CUTOFF_UUR = 24;
  var CUTOFF_MINUUT = 0;

  /* Nederlandse feestdagen waarop niet bezorgd wordt. Bijwerken: één keer per jaar. */
  var FEESTDAGEN = [
    '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-28', '2027-03-29', '2027-04-27',
    '2027-05-06', '2027-05-16', '2027-05-17', '2027-12-25', '2027-12-26',
  ];

  var DAGNAMEN = [
    'zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag',
  ];

  /* De wandklok in Nederland, losgekoppeld van de instelling van de bezoeker. */
  function nuInNederland() {
    var delen = {};
    new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
      .formatToParts(new Date())
      .forEach(function (deel) {
        delen[deel.type] = deel.value;
      });

    /* Uur 24 bestaat in sommige omgevingen als middernacht. */
    var uur = parseInt(delen.hour, 10) % 24;

    return {
      jaar: parseInt(delen.year, 10),
      maand: parseInt(delen.month, 10),
      dag: parseInt(delen.day, 10),
      uur: uur,
      minuut: parseInt(delen.minute, 10),
      seconde: parseInt(delen.second, 10),
    };
  }

  function alsUtc(jaar, maand, dag, uur, minuut, seconde) {
    return new Date(Date.UTC(jaar, maand - 1, dag, uur || 0, minuut || 0, seconde || 0));
  }

  function isoDatum(d) {
    return (
      d.getUTCFullYear() +
      '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getUTCDate()).padStart(2, '0')
    );
  }

  function wordtErBezorgd(d) {
    if (d.getUTCDay() === 0) return false;
    return FEESTDAGEN.indexOf(isoDatum(d)) === -1;
  }

  function eerstvolgendeBezorgdag(vanaf) {
    var d = new Date(vanaf.getTime());
    for (var pogingen = 0; pogingen < 14; pogingen++) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (wordtErBezorgd(d)) return d;
    }
    return null;
  }

  /* Geeft null terug als er niets zinnigs te beloven valt. */
  function belofte() {
    var nu = nuInNederland();
    var vandaag = alsUtc(nu.jaar, nu.maand, nu.dag);
    var nuMs = alsUtc(nu.jaar, nu.maand, nu.dag, nu.uur, nu.minuut, nu.seconde).getTime();
    var cutoffMs = alsUtc(nu.jaar, nu.maand, nu.dag, CUTOFF_UUR, CUTOFF_MINUUT, 0).getTime();

    /* Met middernacht als grens bestaat er geen moment "na de uiterste tijd": zodra
       die voorbij is, is het de volgende dag en telt die dag zijn eigen klok af. */
    var doelMs = cutoffMs;
    var bezorging = eerstvolgendeBezorgdag(vandaag);
    if (!bezorging) return null;

    var morgen = new Date(vandaag.getTime());
    morgen.setUTCDate(morgen.getUTCDate() + 1);

    var resterend = Math.max(0, Math.floor((doelMs - nuMs) / 1000));

    return {
      seconden: resterend,
      dagnaam: isoDatum(bezorging) === isoDatum(morgen) ? 'morgen' : DAGNAMEN[bezorging.getUTCDay()],
    };
  }

  /* Vaste breedte, dus altijd twee cijfers. Anders springt de regel elke keer dat er
     een cijfer bij of af gaat. */
  function klokweergave(seconden) {
    var uren = Math.floor(seconden / 3600);
    var minuten = Math.floor((seconden % 3600) / 60);
    var rest = seconden % 60;

    return (
      String(uren).padStart(2, '0') +
      ':' +
      String(minuten).padStart(2, '0') +
      ':' +
      String(rest).padStart(2, '0')
    );
  }

  function maakElement(plek) {
    var el = document.createElement('p');
    el.className = 'bezorgklok bezorgklok--' + plek;
    el.innerHTML =
      '<span class="bezorgklok__stip" aria-hidden="true"></span>' +
      '<span class="bezorgklok__tekst"></span>';
    return el;
  }

  /* Elk aangemeld element krijgt een vorm mee. In de kopbalk is de ruimte krap en
     staat de regel naast drie andere beloftes; daar leest "Besteld binnen 10:27 =
     morgen in huis" korter en sluit het aan bij de schrijfwijze die elders op de site
     al gebruikt wordt. Op de productpagina en in de winkelwagen is er ruimte voor de
     hele zin. Ingesteld op verzoek van Stijn, 2026-09-03. */
  var elementen = [];

  function meldAan(el, vorm) {
    elementen.push({ el: el, vorm: vorm || 'lang' });
  }

  function ververs() {
    var b = belofte();
    if (!b) return;

    var klok = '<strong>' + klokweergave(b.seconden) + '</strong>';
    var teksten = {
      lang: 'Besteld binnen ' + klok + ' en het wordt ' + b.dagnaam + ' bezorgd',
      kort: 'Besteld binnen ' + klok + ' = ' + b.dagnaam + ' in huis',
    };

    elementen.forEach(function (item) {
      var vak = item.el.querySelector('.bezorgklok__tekst');
      var tekst = teksten[item.vorm] || teksten.lang;
      if (vak && vak.innerHTML !== tekst) vak.innerHTML = tekst;
    });
  }

  /* Productpagina: in het bestaande icoonrijtje, op de regel die nu over de
     besteltijd gaat. Op verzoek van Stijn (2026-09-03) komt de klok daar te staan en
     niet als losse regel onder de bestelknop — het vrachtwagen-icoon en de plek in de
     rij blijven dus staan, alleen de tekst wordt levend.

     Via JavaScript en niet via de sjablonen: die regel staat in 27 losse
     producttemplates, en zo staat hij ook meteen goed op elk nieuw product.

     De juiste regel wordt gezocht op inhoud en niet op volgorde. Verschuift Stijn de
     icoontjes in de thema-editor, dan blijft de klok op de bezorgregel zitten. */
  function plaatsOpProductpagina() {
    var knop = document.querySelector('#MainContent product-form button[name="add"]');
    if (!knop) return;

    /* Uitverkocht: dan laten we de bestaande tekst met rust. Een tikkende klok bij
       iets wat niet te bestellen is, is een belofte die niet waargemaakt kan worden. */
    if (knop.hasAttribute('disabled')) return;

    var regels = document.querySelectorAll('#MainContent .icon-with-text__item');
    for (var i = 0; i < regels.length; i++) {
      var vak = regels[i].querySelector('span');
      if (!vak) continue;

      var tekst = vak.textContent.toLowerCase();
      var gaatOverBezorging =
        tekst.indexOf('23:59') !== -1 ||
        tekst.indexOf('morgen in huis') !== -1 ||
        tekst.indexOf('bezorgd') !== -1;

      if (!gaatOverBezorging) continue;
      if (vak.querySelector('.bezorgklok__tekst')) return;

      vak.innerHTML = '<span class="bezorgklok__tekst"></span>';
      meldAan(vak, 'lang');
      return;
    }
  }

  /* Winkelwagenlade: boven de afrekenknop. De lade wordt opnieuw opgebouwd zodra er
     iets verandert, dus we kijken of hij er nog staat en zetten hem er anders opnieuw
     in. */
  function plaatsInLade() {
    var lade = document.querySelector('cart-drawer');
    if (!lade) return;

    var voet = lade.querySelector('.cart-drawer__footer');
    if (!voet || voet.querySelector('.bezorgklok--lade')) return;

    var el = maakElement('lade');
    var totalen = voet.querySelector('.totals');
    if (totalen) {
      voet.insertBefore(el, totalen);
    } else {
      voet.appendChild(el);
    }
    meldAan(el, 'lang');
    ververs();
  }

  /* Winkelwagenpagina: boven het totaal, net als in de lade. Zelfde opbouw, ander
     omhulsel — de pagina gebruikt .cart__footer en niet .cart-drawer__footer. */
  function plaatsOpWinkelwagenpagina() {
    var voet = document.querySelector('#MainContent .cart__footer');
    if (!voet || voet.querySelector('.bezorgklok--winkelwagen')) return;

    var totalen = voet.querySelector('.totals');
    if (!totalen) return;

    var el = maakElement('winkelwagen');
    totalen.parentElement.insertBefore(el, totalen);
    meldAan(el, 'lang');
  }

  /* Vertrouwensbalk onder de kopbalk: de regel die over de besteltijd gaat wordt een
     levende klok. Toegevoegd 2026-09-03 bij het kopbalk-concept.

     Op inhoud gezocht en niet op volgorde, net als op de productpagina: verschuift
     Stijn de vier regels of laat hij er een weg, dan blijft de klok op de juiste
     staan. Alleen de tekst binnen het item wordt vervangen; het icoon ervoor blijft. */
  function plaatsInVertrouwensbalk() {
    /* Zelfde behandeling voor de belofte in het uitklapmenu: die staat er in dezelfde
       vorm (pictogram in de eerste span, tekst in de laatste). */
    var items = document.querySelectorAll('.vtb__item, .agmm__belofte');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.querySelector('.bezorgklok__tekst')) continue;

      var tekst = item.textContent.toLowerCase();
      var gaatOverBezorging =
        tekst.indexOf('23:59') !== -1 ||
        tekst.indexOf('morgen in huis') !== -1 ||
        tekst.indexOf('bezorgd') !== -1;
      if (!gaatOverBezorging) continue;

      /* De laatste span is de tekst; het icoon staat in de eerste. */
      var spans = item.querySelectorAll('span');
      var vak = spans[spans.length - 1];
      if (!vak) continue;
      if (vak.classList.contains('vtb__icoon') || vak.classList.contains('agmm__beloftepictogram')) continue;

      /* ververs() zoekt binnen elk aangemeld element naar een kind met de klasse
         .bezorgklok__tekst. Het element zelf die klasse geven werkt dus niet: dan
         vindt hij niets en blijft de regel leeg. Hier een omhulsel met het vak erin,
         net als op de productpagina.

         Korte vorm: in deze balk staat de regel naast drie andere beloftes.

         Géén `return` hier, en dat is met opzet. Er zijn twee plekken met deze regel:
         de informatiebalk onder de kopbalk en het uitklapmenu. Het menu staat eerder
         in de pagina, dus met een return stopte de lus daar en bleef de balk zelf op
         de statische tekst staan. Elk item wordt maar één keer opgepakt dankzij de
         controle op .bezorgklok__tekst hierboven. */
      vak.innerHTML = '<span class="bezorgklok__tekst"></span>';
      meldAan(vak, 'kort');
    }
  }


  /* Bundel-hero op de homepage: de regel onderaan de kaart over de besteltijd.

     Hier géén .bezorgklok-klasse erbij: die zet de tekstkleur op de donkere
     voorgrondkleur van het thema, en op een blauwe kaart moet de regel wit blijven. De
     kaart houdt dus zijn eigen opmaak; alleen het bolletje en de cijfers komen hiervan.

     De lange schrijfwijze, want op die kaart is ruimte zat. */
  function plaatsInBanner() {
    var regels = document.querySelectorAll('.bh__lever');
    for (var i = 0; i < regels.length; i++) {
      var el = regels[i];
      if (el.querySelector('.bezorgklok__tekst')) continue;

      var tekst = el.textContent.toLowerCase();
      if (
        tekst.indexOf('23:59') === -1 &&
        tekst.indexOf('morgen in huis') === -1 &&
        tekst.indexOf('bezorgd') === -1
      ) {
        continue;
      }

      el.innerHTML =
        '<span class="bezorgklok__stip" aria-hidden="true"></span>' +
        '<span class="bezorgklok__tekst"></span>';
      meldAan(el, 'lang');
    }
  }

  function opruimen() {
    elementen = elementen.filter(function (item) {
      return item.el.isConnected;
    });
  }

  plaatsOpProductpagina();
  plaatsOpWinkelwagenpagina();
  plaatsInLade();
  plaatsInVertrouwensbalk();
  plaatsInBanner();
  ververs();

  var lade = document.querySelector('cart-drawer');
  if (lade) {
    new MutationObserver(function () {
      opruimen();
      plaatsInLade();
    }).observe(lade, { childList: true, subtree: true });
  }

  setInterval(function () {
    opruimen();
    ververs();
  }, 1000);
})();
/* Opnieuw doorgezet 2026-09-03: de vorige versie bleef in de cache hangen. */
